import isFullwidthCodePoint from 'is-fullwidth-code-point'
import reject from 'lodash/reject'

const THAI_VOWELS_RANGE_1 = ['ะ'.codePointAt(0), 'ู'.codePointAt(0)]
const THAI_VOWELS_RANGE_2 = ['เ'.codePointAt(0), '๎'.codePointAt(0)]

export function isThaiVowel(char = ''): boolean {
  const code = char.codePointAt(0)
  return (
    !!code &&
    !!THAI_VOWELS_RANGE_1[0] &&
    !!THAI_VOWELS_RANGE_1[1] &&
    !!THAI_VOWELS_RANGE_2[0] &&
    !!THAI_VOWELS_RANGE_2[1] &&
    ((code >= THAI_VOWELS_RANGE_1[0] && code <= THAI_VOWELS_RANGE_1[1]) ||
      (code >= THAI_VOWELS_RANGE_2[0] && code <= THAI_VOWELS_RANGE_2[1]))
  )
}

export function isSkinModifier(char = ''): boolean {
  const code = char.codePointAt(0)
  return !!code && code >= 0x1f3fb && code <= 0x1f3ff
}

export function getFirstLetter(word = ''): string {
  const iterator = word[Symbol.iterator]()
  const firstLetter = iterator.next().value || ''
  const nextLetter = iterator.next().value || ''

  if (isSkinModifier(nextLetter)) {
    return firstLetter + nextLetter
  }

  return firstLetter
}

export function isFullwidth(letter: string): boolean {
  const codePoint = letter.codePointAt(0)

  if (codePoint) {
    const isFullwidthCodePointResult = isFullwidthCodePoint(codePoint)
    if (isFullwidthCodePointResult) {
      return isFullwidthCodePointResult
    }
  }

  return letter.length > 1
}

export function getAcronym(title = ''): string {
  const words = reject(title.toUpperCase(), isThaiVowel).join('').split(' ')

  if (words[0].length === 0) {
    return ''
  }

  const firstLetter = getFirstLetter(words[0]) || ''
  const secondLetter = getFirstLetter(words[1]) || ''
  if (isFullwidth(firstLetter) || isFullwidth(secondLetter)) {
    return firstLetter
  }

  return firstLetter + secondLetter
}
